module.exports = __webpack_public_path__ + "static/media/3.a6be42f1.jpg";